/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const PURCHASE_STATE_OPTIONS = [
  { value: "", label: "All" },
  { value: "GATE_IN", label: "Gate in" },
  { value: "WEIGH_GROSS", label: "Weigh gross" },
  { value: "LAB_PENDING", label: "Lab pending" },
  { value: "BARGAINING", label: "Bargaining" },
  { value: "APPROVED", label: "Approved" },
  { value: "UNLOADING", label: "Unloading" },
  { value: "UNLOADING_HOLD", label: "Unloading hold" },
  { value: "RELAB_PENDING", label: "Relab pending" },
  { value: "WEIGH_TARE", label: "Weigh tare" },
  { value: "ACCOUNTS_PENDING", label: "Accounts pending" },
  { value: "COMPLETED", label: "Completed" },
  { value: "REJECTED", label: "Rejected" },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const PURCHASE_COLUMNS = [
  { id: "created_at", label: "Date", accessorKey: "created_at", filterType: "date", sortable: true },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "code", label: "Code", accessorKey: "code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "variety", label: "Variety", accessorKey: "variety", filterType: "text" },
  { id: "bags_reported", label: "Bags", accessorKey: "bags_reported", filterType: "text" },
  { id: "net_weight_qtl", label: "Net (qtl)", accessorKey: "net_weight_qtl", filterType: "text" },
  { id: "negotiated_rate", label: "Rate", accessorKey: "negotiated_rate", filterType: "text" },
  {
    id: "state",
    label: "State",
    accessorKey: "state",
    filterType: "select",
    filterOptions: PURCHASE_STATE_OPTIONS,
    matchFilter: (row, value) => !value || row.state === value,
  },
  { id: "gate_pass_code", label: "Gate pass", accessorKey: "gate_pass_code", filterType: "text", hideInTable: true },
  { id: "assigned_to", label: "Assigned", accessorKey: "assigned_to", filterType: "text", hideInTable: true },
];
